// Google Analytics 4 (GA4) helper
// Measurement ID is loaded via gtag snippet in /public/index.html
// We disable automatic page_view there and fire it manually on each route change.

const isGtagReady = () => typeof window !== "undefined" && typeof window.gtag === "function";

/** Fire a GA4 page_view event for the given path. */
export const trackPageView = (path, title) => {
  if (!isGtagReady()) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.origin + path,
    page_title: title || document.title,
  });
};

/** Fire a custom GA4 event. */
export const trackEvent = (eventName, params = {}) => {
  if (!isGtagReady()) return;
  window.gtag("event", eventName, params);
};

/** Identify the logged-in user (no PII — just user id). */
export const setUserId = (userId) => {
  if (!isGtagReady() || !userId) return;
  window.gtag("set", { user_id: String(userId) });
};
